import React, { memo } from 'react';
import classNames from 'classnames/bind';
import styles from './Skeleton.module.scss';

const cx = classNames.bind(styles);

const Skeleton = (props) => {
	const { width = null, height = null, backgroundColor = '#eee', line = 1, lineMarginTop = null, radius = null, isHeightMax = false, isCenter } = props;
	const style = {
		width,
		height: isHeightMax ? '100%' : height,
		backgroundColor,
		margin: isCenter && '0 auto',
		marginTop: lineMarginTop,
		borderRadius: radius,
	};
	const tag = [...new Array(line)].map((result, i) => {
		const key = `${result}${i}`;
		return (
			<div
				key={key}
				className={cx('item')}
				style={style}
			/>
		);
	});
	return tag;
};

export default memo(Skeleton);
